export default "__VITE_PUBLIC_ASSET__5ccb3d70__"